import { createAsyncThunk } from "@reduxjs/toolkit";

import { getProject } from "@/models";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

export const fetchProject = createAsyncThunk(
  "project/fetchProject",
  async (
    params: { projectId: string; config?: object },
    { getState, rejectWithValue }
  ) => {
    const { token } = fetchAuthToken(getState());
    try {
      const { adapter } = getState() as AppState;
      const { baseUrl } = adapter.adapter;
      const { projectId, config } = params;
      const response = await getProject(token, baseUrl, projectId, {}, config);

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
